// Brand
export const BRAND_NAME = "suewag";

// businesscardAuthor
export const BUSINESSCARD_AUTHOR_ALIGNMENT_LEFT = "left";
export const BUSINESSCARD_AUTHOR_ALIGNMENT_CENTER = "center";
export const BUSINESSCARD_AUTHOR_ALIGNMENT_RIGHT = "right";
export const BUSINESSCARD_AUTHOR_ALIGNMENT = [
  BUSINESSCARD_AUTHOR_ALIGNMENT_LEFT,
  BUSINESSCARD_AUTHOR_ALIGNMENT_CENTER,
  BUSINESSCARD_AUTHOR_ALIGNMENT_RIGHT
] as const;
export type BusinesscardAuthorAlignment = typeof BUSINESSCARD_AUTHOR_ALIGNMENT[number];
//defaultAlignment
export const BUSINESSCARD_AUTHOR_DEFAULT_ALIGNMENT = "left";

// businesscardContact
export const BUSINESSCARD_CONTACT_ALIGNMENT_LEFT = "left";
export const BUSINESSCARD_CONTACT_ALIGNMENT_CENTER = "center";
export const BUSINESSCARD_CONTACT_ALIGNMENT_RIGHT = "right";
export const BUSINESSCARD_CONTACT_ALIGNMENT = [
  BUSINESSCARD_CONTACT_ALIGNMENT_LEFT,
  BUSINESSCARD_CONTACT_ALIGNMENT_CENTER,
  BUSINESSCARD_CONTACT_ALIGNMENT_RIGHT
] as const;
export type BusinesscardContactAlignment = typeof BUSINESSCARD_CONTACT_ALIGNMENT[number];
//defaultAlignment
export const BUSINESSCARD_CONTACT_DEFAULT_ALIGNMENT = "left";

// dateEvent
export const DATE_EVENT_ALIGNMENT_LEFT = "left";
export const DATE_EVENT_ALIGNMENT_RIGHT = "right";
export const DATE_EVENT_ALIGNMENT = [DATE_EVENT_ALIGNMENT_LEFT, DATE_EVENT_ALIGNMENT_RIGHT] as const;
export type DateEventAlignment = typeof DATE_EVENT_ALIGNMENT[number];
//defaultAlignment
export const DATE_EVENT_DEFAULT_ALIGNMENT = "left";

// headline
export const HEADLINE_ALIGNMENT_LEFT = "left";
export const HEADLINE_ALIGNMENT_CENTER = "center";
export const HEADLINE_ALIGNMENT_RIGHT = "right";
export const HEADLINE_ALIGNMENT = [
  HEADLINE_ALIGNMENT_LEFT,
  HEADLINE_ALIGNMENT_CENTER,
  HEADLINE_ALIGNMENT_RIGHT
] as const;
export type HeadlineAlignment = typeof HEADLINE_ALIGNMENT[number];
//defaultAlignment

// pageHeader
export const PAGE_HEADER_ALIGNMENT_LEFT = "left";
export const PAGE_HEADER_ALIGNMENT_CENTER = "center";
export const PAGE_HEADER_ALIGNMENT_RIGHT = "right";
export const PAGE_HEADER_ALIGNMENT = [
  PAGE_HEADER_ALIGNMENT_LEFT,
  PAGE_HEADER_ALIGNMENT_CENTER,
  PAGE_HEADER_ALIGNMENT_RIGHT
] as const;
export type PageHeaderAlignment = typeof PAGE_HEADER_ALIGNMENT[number];
//defaultAlignment
export const PAGE_HEADER_DEFAULT_ALIGNMENT = "left";

// pictogram
export const PICTOGRAM_ALIGNMENT_LEFT = "left";
export const PICTOGRAM_ALIGNMENT_CENTER = "center";
export const PICTOGRAM_ALIGNMENT_RIGHT = "right";
export const PICTOGRAM_ALIGNMENT = [
  PICTOGRAM_ALIGNMENT_LEFT,
  PICTOGRAM_ALIGNMENT_CENTER,
  PICTOGRAM_ALIGNMENT_RIGHT
] as const;
export type PictogramAlignment = typeof PICTOGRAM_ALIGNMENT[number];
//defaultAlignment
export const PICTOGRAM_DEFAULT_ALIGNMENT = "left";

// stage
export const STAGE_ALIGNMENT_LEFT = "left";
export const STAGE_ALIGNMENT_CENTER = "center";
export const STAGE_ALIGNMENT_RIGHT = "right";
export const STAGE_ALIGNMENT = [STAGE_ALIGNMENT_LEFT, STAGE_ALIGNMENT_CENTER, STAGE_ALIGNMENT_RIGHT] as const;
export type StageAlignment = typeof STAGE_ALIGNMENT[number];
//defaultAlignment

//Squircle configuration
export const IS_SQUIRCLE = false;

// box: TYPE || CONTENT_HORIZONTAL_ALIGNMENT
export const BOX_DEFAULT_CONTENT_HORIZONTAL_ALIGNMENT = "left";
export const BOX_CONTENT_HORIZONTAL_ALIGNMENT_LEFT = "left";
export const BOX_CONTENT_HORIZONTAL_ALIGNMENT_CENTER = "center";

export const BOX_CONTENT_HORIZONTAL_ALIGNMENTS = [
  BOX_CONTENT_HORIZONTAL_ALIGNMENT_LEFT,
  BOX_CONTENT_HORIZONTAL_ALIGNMENT_CENTER
] as const;

export type BoxContentHorizontalAlignment = typeof BOX_CONTENT_HORIZONTAL_ALIGNMENTS[number];

// box: TYPE || CONTENT_VERTICAL_ALIGNMENT
export const BOX_DEFAULT_CONTENT_VERTICAL_ALIGNMENT = "top";
export const BOX_CONTENT_VERTICAL_ALIGNMENT_TOP = "top";
export const BOX_CONTENT_VERTICAL_ALIGNMENT_CENTER = "center";
export const BOX_CONTENT_VERTICAL_ALIGNMENT_BOTTOM = "bottom";

export const BOX_CONTENT_VERTICAL_ALIGNMENTS = [
  BOX_CONTENT_VERTICAL_ALIGNMENT_TOP,
  BOX_CONTENT_VERTICAL_ALIGNMENT_CENTER,
  BOX_CONTENT_VERTICAL_ALIGNMENT_BOTTOM
] as const;

export type BoxContentVerticalAlignment = typeof BOX_CONTENT_VERTICAL_ALIGNMENTS[number];

// cardTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const CARD_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type CardTeaserViolatorHorizontalPosition = typeof CARD_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// cardTeaser: TYPE || VIOLATOR_VERTICAL_POSITION
export const CARD_TEASER_DEFAULT_VIOLATOR_VERTICAL_POSITION = "top";
export const CARD_TEASER_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const CARD_TEASER_VIOLATOR_VERTICAL_POSITION_CENTER = "center";
export const CARD_TEASER_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";

export const CARD_TEASER_VIOLATOR_VERTICAL_POSITIONS = [
  CARD_TEASER_VIOLATOR_VERTICAL_POSITION_TOP,
  CARD_TEASER_VIOLATOR_VERTICAL_POSITION_CENTER,
  CARD_TEASER_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export type CardTeaserViolatorVerticalPosition = typeof CARD_TEASER_VIOLATOR_VERTICAL_POSITIONS[number];

// cardTeaser: TYPE || PROMO_FLAG_ALIGNMENT
export const CARD_TEASER_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const CARD_TEASER_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const CARD_TEASER_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const CARD_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const CARD_TEASER_PROMO_FLAG_ALIGNMENTS = [
  CARD_TEASER_PROMO_FLAG_ALIGNMENT_LEFT,
  CARD_TEASER_PROMO_FLAG_ALIGNMENT_CENTER,
  CARD_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type CardTeaserPromoFlagAlignment = typeof CARD_TEASER_PROMO_FLAG_ALIGNMENTS[number];

// checkbox: TYPE || GROUP_LABEL_FORMAT
export const CHECKBOX_DEFAULT_GROUP_LABEL_FORMAT = "copy";
export const CHECKBOX_GROUP_LABEL_FORMAT_H3 = "h3";
export const CHECKBOX_GROUP_LABEL_FORMAT_H4 = "h4";
export const CHECKBOX_GROUP_LABEL_FORMAT_H5 = "h5";
export const CHECKBOX_GROUP_LABEL_FORMAT_ABSTRACT = "abstract";
export const CHECKBOX_GROUP_LABEL_FORMAT_COPY = "copy";
export const CHECKBOX_GROUP_LABEL_FORMAT_COPY_SMALL = "copy-small";

export const CHECKBOX_GROUP_LABEL_FORMATS = [
  CHECKBOX_GROUP_LABEL_FORMAT_H3,
  CHECKBOX_GROUP_LABEL_FORMAT_H4,
  CHECKBOX_GROUP_LABEL_FORMAT_H5,
  CHECKBOX_GROUP_LABEL_FORMAT_ABSTRACT,
  CHECKBOX_GROUP_LABEL_FORMAT_COPY,
  CHECKBOX_GROUP_LABEL_FORMAT_COPY_SMALL
] as const;

export type CheckboxGroupLabelFormat = typeof CHECKBOX_GROUP_LABEL_FORMATS[number];

// image: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const IMAGE_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const IMAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const IMAGE_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const IMAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const IMAGE_VIOLATOR_HORIZONTAL_POSITIONS = [
  IMAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  IMAGE_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  IMAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type ImageViolatorHorizontalPosition = typeof IMAGE_VIOLATOR_HORIZONTAL_POSITIONS[number];

// image: TYPE || VIOLATOR_VERTICAL_POSITION
export const IMAGE_DEFAULT_VIOLATOR_VERTICAL_POSITION = "top";
export const IMAGE_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const IMAGE_VIOLATOR_VERTICAL_POSITION_CENTER = "center";
export const IMAGE_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";

export const IMAGE_VIOLATOR_VERTICAL_POSITIONS = [
  IMAGE_VIOLATOR_VERTICAL_POSITION_TOP,
  IMAGE_VIOLATOR_VERTICAL_POSITION_CENTER,
  IMAGE_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export type ImageViolatorVerticalPosition = typeof IMAGE_VIOLATOR_VERTICAL_POSITIONS[number];

// multiContentStage: TYPE || PROMO_FLAG_ALIGNMENT
export const MULTI_CONTENT_STAGE_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENTS = [
  MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_LEFT,
  MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_CENTER,
  MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type MultiContentStagePromoFlagAlignment = typeof MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENTS[number];

// pageHeader: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const PAGE_HEADER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITIONS = [
  PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type PageHeaderViolatorHorizontalPosition = typeof PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// stage: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const STAGE_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const STAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const STAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const STAGE_VIOLATOR_HORIZONTAL_POSITIONS = [
  STAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  STAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type StageViolatorHorizontalPosition = typeof STAGE_VIOLATOR_HORIZONTAL_POSITIONS[number];

// textTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const TEXT_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type TextTeaserViolatorHorizontalPosition = typeof TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// textTeaser: TYPE || PROMO_FLAG_ALIGNMENT
export const TEXT_TEASER_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const TEXT_TEASER_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const TEXT_TEASER_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const TEXT_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const TEXT_TEASER_PROMO_FLAG_ALIGNMENTS = [
  TEXT_TEASER_PROMO_FLAG_ALIGNMENT_LEFT,
  TEXT_TEASER_PROMO_FLAG_ALIGNMENT_CENTER,
  TEXT_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type TextTeaserPromoFlagAlignment = typeof TEXT_TEASER_PROMO_FLAG_ALIGNMENTS[number];

// tilesTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const TILES_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "center";
export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type TilesTeaserViolatorHorizontalPosition = typeof TILES_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// violator: TYPE || ALIGNMENT
export const VIOLATOR_DEFAULT_ALIGNMENT = "center";
export const VIOLATOR_ALIGNMENT_CENTER = "center";

export const VIOLATOR_ALIGNMENTS = [VIOLATOR_ALIGNMENT_CENTER] as const;

export type ViolatorAlignment = typeof VIOLATOR_ALIGNMENTS[number];

// violator: TYPE || POSITION
export const VIOLATOR_DEFAULT_POSITION = "center";
export const VIOLATOR_POSITION_TOP = "top";
export const VIOLATOR_POSITION_CENTER = "center";
export const VIOLATOR_POSITION_BOTTOM = "bottom";

export const VIOLATOR_POSITIONS = [VIOLATOR_POSITION_TOP, VIOLATOR_POSITION_CENTER, VIOLATOR_POSITION_BOTTOM] as const;

export type ViolatorPosition = typeof VIOLATOR_POSITIONS[number];

// violator: TYPE || PICTOGRAM_POSITION
export const VIOLATOR_DEFAULT_PICTOGRAM_POSITION = "center";
export const VIOLATOR_PICTOGRAM_POSITION_CENTER = "center";

export const VIOLATOR_PICTOGRAM_POSITIONS = [VIOLATOR_PICTOGRAM_POSITION_CENTER] as const;

export type ViolatorPictogramPosition = typeof VIOLATOR_PICTOGRAM_POSITIONS[number];

//Icon
export const ICON_CDN_URL = "https://revumbuiicons.blob.core.windows.net/$web/q";
export const ICON_VERSION = "1.0.13-suewag";

/* Component wise configuration */
// accordion
export const ACCORDION_SHOW_BAR = true as const;
// businesscardContact
export const BUSINESSCARD_CONTACT_HEADLINE_SIZE = "h2" as const;
export const BUSINESSCARD_CONTACT_HEADLINE_SEO_TAG = "h2" as const;
// cardTeaser
export const CARD_TEASER_TEXT_POSITION = ["left", "center"] as const;
// contentAggregator
export const CONTENT_AGGREGATOR_BACKGROUND_FOR_COLORFUL_VARIANT = "eon-bright-white" as const;
export const CONTENT_AGGREGATOR_COLORFUL_VARIANT_COLORS = ["mellowYellowBright", "brightWhite"] as const;
export const CONTENT_AGGREGATOR_TILE_BRIGHT_COLOR_SCHEME = "brightWhite" as const;
export const CONTENT_AGGREGATOR_TILE_DEFAULT_COLOR_SCHEME = "atmosphericAnthracite5" as const;
export const CONTENT_AGGREGATOR_HEADLINE_ALIGNMENT = "left" as const;
// contentAggregatorItem
export const CONTENT_AGGREGATOR_ITEM_ALTERNATIVE_TAG_PILL_SCHEME = "pulsingPurpleBright" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_TILE_LARGE = "h2" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_TILE_SMALL = "h3" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_LIST_LARGE = "h5" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_LIST_SMALL = "copy" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_ALIGNMENT = "left" as const;
export const CONTENT_AGGREGATOR_ITEM_CONTENT_ALIGNMENT = "left" as const;
// contextMenuItem
export const CONTEXT_MENU_ITEM_ACTIVE_ICON_SIZE = "tiny" as const;
// dataTable
export const DATA_TABLE_TOOLBAR_SELECTED_INNER_BACKGROUND = "eon-mellow-yellow-bright" as const;
export const DATA_TABLE_SEARCH_ICON_NAME = "magnifier" as const;
export const DATA_TABLE_SORT_ICON_NAME = "chevron_small_up" as const;
export const DATA_TABLE_EXPANDABLE_ICON_NAME = "arrow_down" as const;
// dropdown
export const DROPDOWN_CHEVRON_ICON_NAME = "chevron_bold_down" as const;
// dropdown
export const DROPDOWN_CHEVRON_SMALL_ICON_NAME = "chevron_small_down" as const;
// fileUpload
export const FILE_UPLOAD_SUMMERY_BACKGROUND_SCHEME = "eon-bright-white" as const;
// fileUpload
export const FILE_UPLOAD_SUCCESS_PROGRESS_ICON_COLOR = "eon-mellow-yellow-bright" as const;
// fileUpload
export const FILE_UPLOAD_SUCCESS_PROGRESS_TEXT_COLOR = "eon-mellow-yellow-bright" as const;
// fileUpload
export const FILE_UPLOAD_ERROR_PROGRESS_ICON_COLOR = "eon-bright-white" as const;
// fileUpload
export const FILE_UPLOAD_ERROR_PROGRESS_TEXT_COLOR = "eon-bright-white" as const;
// fileUpload
export const FILE_UPLOAD_ERROR_PROGRESS_SCHEME = "radiantRedBright" as const;
// footerBar
export const FOOTER_BAR_SHOW_COLOR_SEPARATOR = true as const;
// headline
export const HEADLINE_H1_ALIGNMENT = ["left", "center", "right"] as const;
export const HEADLINE_H2_ALIGNMENT = ["left", "center", "right"] as const;
export const HEADLINE_H3_ALIGNMENT = ["left", "center", "right"] as const;
export const HEADLINE_H4_ALIGNMENT = ["left", "center", "right"] as const;
export const HEADLINE_H5_ALIGNMENT = ["left", "center", "right"] as const;
export const HEADLINE_COPY_ALIGNMENT = ["left", "center", "right"] as const;
// headline
export const HEADLINE_SCHEMES_ON_BACKGROUND_IMAGE = ["atmosphericAnthracite", "brightWhite"] as const;
// icon
export const ICON_ICON_SCHEME = "atmosphericAnthracite" as const;
// infoIcon
export const INFO_ICON_ICON_NAME = "info_large" as const;
// modal
export const MODAL_FOOTER_COLORS = ["eon-bright-white", "eon-blazing-blue-bright", "eon-mellow-yellow-bright"] as const;
export const MODAL_FOOTER_DEFAULT_COLOR = "eon-bright-white" as const;
export const MODAL_ICON_SCHEME = "atmosphericAnthracite" as const;
export const MODAL_HEADLINE_COLORS = ["atmosphericAnthracite", "mellowYellowBright"] as const;
export const MODAL_DEFAULT_HEADLINE_COLOR = "atmosphericAnthracite" as const;
// navigation
export const NAVIGATION_TOOLBAR_FLYOUT_INNER_BACKGROUND = "eon-atmospheric-anthracite" as const;
export const NAVIGATION_MAIN_FLYOUT_INNER_BACKGROUND = "eon-bright-white" as const;
export const NAVIGATION_MOBILE_FLYOUT_INNER_BACKGROUND = "eon-bright-white" as const;
// offsetTeaser
export const OFFSET_TEASER_COLOR_BARS = [
  "mellow-yellow-bright",
  "pulsing-purple-bright",
  "fiery-fuchsia-bright",
  "radiant-red-bright",
  "galvanic-green-bright",
  "blazing-blue-bright",
  "iridescent-indigo-bright"
] as const;
export const OFFSET_TEASER_HEADLINE_SIZE = "h2" as const;
export const OFFSET_TEASER_SUBHEADLINE_SIZE = "h3" as const;
export const OFFSET_TEASER_CONTENT_ALIGNMENT = "left" as const;
export const OFFSET_TEASER_ALIGNMENT_HEADLINE = "right" as const;
export const OFFSET_TEASER_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
export const OFFSET_TEASER_TWO_ALIGNMENT_HEADLINE = "left" as const;
export const OFFSET_TEASER_TWO_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
export const OFFSET_TEASER_THREE_ALIGNMENT_HEADLINE = "left" as const;
export const OFFSET_TEASER_THREE_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
export const OFFSET_TEASER_FOUR_ALIGNMENT_HEADLINE = "left" as const;
export const OFFSET_TEASER_FOUR_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
export const OFFSET_TEASER_FIVE_ALIGNMENT_HEADLINE = "right" as const;
export const OFFSET_TEASER_FIVE_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
// pageHeader
export const PAGE_HEADER_COLOR_BARS = ["mellow-yellow-bright"] as const;
export const PAGE_HEADER_HEADLINE_SCHEME_SHADOW_MAP = [{ pulsingPurpleBright: false }, { brightWhite: true }] as const;
export const PAGE_HEADER_HEADLINE_SIZE = "h1" as const;
export const PAGE_HEADER_HEADLINE_ALIGNMENT = "left" as const;
export const PAGE_HEADER_CONTENT_ALIGNMENT = "left" as const;
export const PAGE_HEADER_SUBHEADLINE_SIZE = "h5" as const;
export const PAGE_HEADER_DEFAULT_ENABLING_CONTRAST_BARS = false as const;
// radioButton
export const RADIO_BUTTON_GROUP_LABEL_FORMAT = ["h3", "h4", "h5", "abstract", "copy", "copy-small"] as const;
// section
export const SECTION_SHOW_FOOTER_SEPARATOR = false as const;
// stage
export const STAGE_DEFAULT_ALIGNMENT = "left" as const;
export const STAGE_DEFAULT_CONTENT_WIDTH = "narrow" as const;
// step
export const STEP_PICTOGRAM_SIZE = "extra-small" as const;
// textTeaser
export const TEXT_TEASER_HEADLINE_SIZES = ["h1", "h2", "h3"] as const;
export const TEXT_TEASER_HEADLINE_SIZE = "h3" as const;
export const TEXT_TEASER_DEFAULT_HEADLINE_ALIGNMENT = "left" as const;
export const TEXT_TEASER_CONTENT_ALIGNMENT = "left" as const;
export const TEXT_TEASER_PICTOGRAM_ALIGNMENT = "left" as const;
export const TEXT_TEASER_NUMBER_ALIGNMENT = "left" as const;
export const TEXT_TEASER_PICTOGRAM_WITH_NUMBER_ALIGNMENT = "left" as const;
export const TEXT_TEASER_DEFAULT_HEADLINE_WITH_NUMBER_ALIGNMENT = "left" as const;
export const TEXT_TEASER_CONTENT_WITH_NUMBER_ALIGNMENT = "left" as const;
// tilesTeaser
export const TILES_TEASER_COLORS = ["brightWhite", "mellowYellowBright", "atmosphericAnthracite"] as const;
export const TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT = ["left", "center", "right"] as const;
export const TILES_TEASER_DEFAULT_HORIZONTAL_CONTENT_ALIGNMENT = "left" as const;
export const TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT = ["top", "center", "bottom"] as const;
export const TILES_TEASER_DEFAULT_VERTICAL_CONTENT_ALIGNMENT = "bottom" as const;
// tooltip
export const TOOLTIP_CONTENT_ALIGNMENT = ["left", "center"] as const;
export const TOOLTIP_DEFAULT_CONTENT_ALIGNMENT = "left" as const;
// videoplayer
export const VIDEOPLAYER_BUTTON_SCHEME = "atmosphericAnthracite" as const;
